import React, { FunctionComponent } from 'react';

import { StyledInput, StyledInputProps } from './styled';

export type InputProps = StyledInputProps;

const Input: FunctionComponent<InputProps> = ({
  fluid = false,
  ...props
}: InputProps) => {
  return <StyledInput fluid={fluid} {...props} />;
};

export default Input;
